import moment from 'moment';
import { map } from 'lodash/fp';

export const STANDARD_FORMAT = 'YYYY-MM-DD';

export const toStandardDate = date => moment(date).format(STANDARD_FORMAT);

export const toDateObject = date => moment(date).toDate();

export const formatDateRange = map(toStandardDate);

export const toObjectDateRange = map(toDateObject);

export const toDisplayDateTime = date => moment(date).format('lll');
